import { API_METHODS } from "../../constant";
export const hrFeedFields = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_HrFeedFields]: () => {
      let urlReq = `/HrFeedFields/${paramsIn.id}`;
      return _get(urlReq);
    },

    [API_METHODS.GET_ALL_HrFeedFields]: () => {
      let urlReq = `/HrFeedFields`;
      return _getAll(urlReq);
    },

    [API_METHODS.UPDATE_HrFeedFields]: () => {
      let urlReq = `/HrFeedFields`;
      return _update(urlReq);
    },

    [API_METHODS.CREATE_HrFeedFields]: () => {
      let urlReq = `/HrFeedFields`;
      return _create(urlReq);
    },

    [API_METHODS.DELETE_HrFeedFields]: () => {
      let urlReq = `/HrFeedFields/${paramsIn.id}`;
      return _delete(urlReq);
    }
  };
};

